<template>
  <div :class="{
    'article deak': this.$route.name === 'deak',
    'article csorbics': this.$route.name === 'csorbics',
    'article suto': this.$route.name === 'suto'
    }">
    <template v-if="this.$route.name === 'deak'">
      <img
        class="leadbg"
        src="../assets/article/deak-bg.jpg"
      >
    </template>
    <template v-if="this.$route.name === 'csorbics'">
      <img
        class="leadbg"
        src="../assets/article/csorbics-bg.jpg"
      >
    </template>
    <template v-if="this.$route.name === 'suto'">
      <img
        class="leadbg"
        src="../assets/article/suto-bg.jpg"
      >
    </template>
    <div class="inner">
      <div class="headlinecont">
        <div class="textcont">
          <template v-if="this.$route.name === 'deak'">
            <h1><span class="lastname">Deák</span><span class="firstname">Gergely</span></h1>
          </template>
          <template v-if="this.$route.name === 'csorbics'">
            <h1><span class="lastname">Csorbics</span><span class="firstname">Benjamin</span></h1>
          </template>
          <template v-if="this.$route.name === 'suto'">
            <h1><span class="lastname">Sütő</span><span class="firstname">László</span></h1>
          </template>
        </div>
      </div>
      <article>
        <template v-if="this.$route.name === 'deak'">
          <h2>Az első aki nem is az első</h2>
          <p>Deák Gergely úgy lett az első pesti borbély, hogy nem is ő az első.
            Furcsa, mi? Gergő, mint minden rendes boldogulni akaró srác, informatikusnak tanult.
            Igaz korán ráébredt, hogy nem ez az ő útja. Az igazi lökést azonban 16 évesen kapta,
            amikor belépett egy igazi borbély üzletbe. Azt mondja, szerelem volt első látásra.</p>
          <p class="quote startq">„Egyből megfogott a hangulat, az életérzés,<br>
            amit csak egy klasszikus borbély szalonban érezhet az ember.” </p>
          <p>Eldöntötte, borbély lesz. Az érettségi után tehát egyenes út vezetett egy
            borbélyképzőbe, onnan pedig egy olyan üzletbe, amelynek tulajdonosa Amerikából
            hozta a mesterség alapjait. Azt mondja, hogy az itt töltött idő azért volt
            különösen fontos a számára, mert a tengerentúlon nem volt olyan szünet a mesterség
            fejlődésében, mint az egykor szebb napokat látott Kelet-Európában. Már itt tudta,
            hogy saját üzletet kell nyitnia. Amikor a tettek mezejére lépett, kiderült, hogy
            nem az első a családban, aki beleszeretett a szakmába,</p>
          <div class="pictureblock">
            <div class="articlepic">
              <img src="../assets/article/deak-article-pic.png">
            </div>
            <div class="textcol">
              <img src="../assets/description-bg.png">
              <div class="colq">
                Édesapja testvére Deák Zoltán<br>
                még a budapesti<br>
                „borbélyforradalom” hajnalán<br>
                nyitott egy üzletet<br>
                Első Pesti Borbély néven.
              </div>
            </div>
          </div>
          <p class="quote">„Azért nevezhette el így mivel a borbély, mint szakma sokáig
            azt hittek,<br>
            hogy be van tiltva az AIDS és a fertőzések veszélye miatt, de ez nem igaz.<br>
            Csak a késes borotva használata tiltott, igaz az a mai napig. </p>
          <p class="quote endq">Amikor a nagybácsi rájött, hogy cserélhető pengést lehet használni,
            egyből kitálalta,<br>
            hogy megcsinálja az első barber shop-ot Pesten”</p>
          <p>- mondja Gergő. A nagybácsi üzlete később kudarcot vallott, amiről a Deák sok
            helyen beszélt már,
            de most szívesen adta a márkanevet az unokaöcs kezébe. </p>
          <p>Így lett Gergő az első pesti borbély két éve, amikor már javában
            dübörgött a barber őrület.</p>
        </template>
        <template v-if="this.$route.name === 'csorbics'">
          <h2>Csorbics Benjamin, a pécsi</h2>
          <p>Benjámin elég korán közel került a szakmához, illetve a fodrászathoz.
            Már az anyukája is fodrász volt. De a szalonban cseperedés nem hozta azonnal a
            szerelmet a borbélyság iránt. Benjámin 22 éves volt, amikor már egy ideje az
            édesanyja szalonjában dolgozva rájött, hogy a borbélyság az, amivel ő igazán
            foglalkozni szeretne.</p>
          <p class="quote startq">„Ekkor itthon még nem igazán voltak elterjedve a
            barber shopok,<br>
            és én sem tudtam róluk túl sokat,<br>
            ám ahogy egyre közelebb kerültem a szakmához és annak rejtelmeihez,<br>
            egyre jobban kezdett érdekelni a tradicionális borbély mesterség.”</p>
          <p>A meghatározó lökést egy dél-amerikai út adta meg. </p>
          <p class="quote">„Az igazi barberekkel akkor találkoztam először,<br>
            amikor 2015-ben Uruguayban jártam. Rögtön megfogott ezeknek a helyeknek a miliője,<br>
            és kis túlzással, már láttam magam előtt a saját barber shopomat. </p>
          <p class="quote endq">Régebben itthon is megvolt ennek a hagyománya, hogy a
            férfiak borbélyhoz
            járnak. Nem csak azért, hogy a hajukat és a szakállunkat levágassák, hanem a
            közösség miatt is. És amellett, hogy minőségi szolgáltatást kapnak, éppen ez utóbbi
            az igazán fontos és meghatározó a vendégek számára.”</p>
          <p>Benjámin 2016-ban nyitott Pécsett, és amiben igazán más az ő üzlete, az
            egy kicsi plusz. Itt ugyanis nem csak a szakáll, vagy a haj fontos, hanem
            kiegészítette a boltot egy különálló tetováló szalonnal is. </p>
          <div class="pictureblock">
            <div class="articlepic">
              <img src="../assets/article/csorbics-article-pic.png">
            </div>
            <div class="textcol">
              <img src="../assets/description-bg.png">
              <div class="colq">
                „Elsőre sikerült egy elképesztően<br>
                jó csapatot összehoznunk, ami jelenleg<br>
                4 borbélyból, 3 tanulóból<br>
                és egy tetováló művészből áll...”
              </div>
            </div>
            <div class="credits">
              Fotó: Steindl Máté
            </div>
          </div>
          <p class="quote startq">“...Nagyon büszkék vagyunk a közösen elért sikereinkre.<br>
            A teljesség igénye nélkül, például 2017-ben elnyertük a Made In Pécs
            „Az év projektje” címet.<br>
            Abban az évben és 2018-ban is a magyarországi American Crew All Star Challenge<br>
            verseny aranyérmesei lettünk.” </p>
          <p>Benjámin azt mondja, az eddigi csaknem 10 ezer vendég igazolta, hogy vidéken is
            van piaca az igényes szalonoknak. Sőt, immár azon dolgozik, hogy Barber Shop Capital
            néven új üzletet nyisson a városban. </p>
          <p class="quote">„Idén az új vízióm megvalósításán dolgozom, a Barber Shop
            Capital szellemében,<br>
            amely egy kicsit megint újragondolja e reneszánszát élő szakmát.
            A haj- és szakállvágást,<br>
            a tetoválást, valamint a jó társaságot kiegészítjük olyan prémium kategóriás
            szolgáltatásokkal,<br>
            mint például a masszázs, vagy az autóval érkező vendégeink részére
            egy autókozmetika az udvarban. </p>
          <p class="quote endq">Utóbbi azért praktikus, mert így a vendég két legyet üt
            egy csapásra:
            amíg a haj és szakáll elkészül, addigra az autó is megtisztul.
            Aki pedig nem járművel érkezik, az elfogyaszthat egy hideg sört is.”</p>
        </template>
        <template v-if="this.$route.name === 'suto'">
          <h2>Aki egyedül dolgozik</h2>
          <p>Sütő László 13 éve döntötte el, hogy borbély lesz. Azt mondja, olyan szakmát
            képzelt el magának mindig is, ami elég laza ahhoz, hogy akár egy életre
            beleszeressen az ember.</p>
          <p class="quote startq">„Nyilván függ attól is, mi a terved vele a jövőben, mennyit
            hozol ki magadból,<br>
            a szakmából, érzed-e annyira az emberekkel való foglalkozást, hogy a kapcsolat,<br>
            amely létrejön a leendő klienseiddel megmaradjon hónapokig, évekig vagy évtizedekig.<br>
            Jelentem az első évtized pipa, a folytatás pedig egyre érdekesebb.” </p>
          <p>Azt is hozzáteszi, hogy bár tudta, hogy a dédapja is borbély volt egy Teréz körúti
            klasszikus üzlettel, de azt gondolta csak akkor mondhatja, hogy az ő nyomdokaiba lép,
            ha komolyan kitanulja a szakmát.
            László Miskolcon tanulta eredetileg a mesterséget, innen katapultált a fővárosba,
            ahol először a hajszobrászok krémjénél próbált minden fortélyt ellesni.</p>
          <p class="quote startq">„Mivel nemigen akartam vesztegetni az időt,<br>
            nekifutásból a lehető legjobb helyet és személyt céloztam meg:<br>
            a Hajast. Tömören az életérzésről, tanulásról, miliőről, ami ott várt:</p>
          <p class="quote"><strong>Mintha általános iskolás technika óráról átigazolnál<br>
              Elon Musk SpaceX-jéhez. Csend, rend fegyelem és végtelen profizmus.</strong><br>
            Ebből a profizmus jött át leginkább.”</p>
          <p>Innen egy multihoz lépett tovább, ahol már oktatófodrász lett. </p>
          <p class="quote startq">„Hátborzongatóan jó érzés szakmát adni a kezébe valakinek,<br>
            aki ezt a szép és összetett művészeti ágat választja.”</p>
          <p>De ez még messze nem az út vége volt Lászlónak. Mint ahogy elég sokan a kezdetekkor,
            ő is megfordult a Gellei testvérek Budapest Barber Shopjában.</p>
          <p class="quote">„Sikerült még az egész »borbély sztorit« az elején elkapni azzal,<br>
            hogy náluk kezdtem el dolgozni.”</p>
          <p>Amikor ide felvételizett a borbélycsapat alig 7 főt számlált, nem valószínű,
            hogy ennél többen lehettek ekkor az országban.</p>
          <p class="quote endq">„Láttuk az üzlet előtt elhaladó embereket, ahogy lelassítanak vagy
            megállnak és felmérik a kirakatot, minket a kötényeinkben, próbálják
            feldolgozni a látványt.<br>
            Mintha egy időkapu nyílt volna meg a múltra.<br>
            Nem biztos, hogy képes vagyok átadni az érzést, amikor...</p>
          <div class="pictureblock">
            <div class="articlepic">
              <img src="../assets/article/suto-article-pic.png">
            </div>
            <div class="textcol">
              <img src="../assets/description-bg.png">
              <div class="colq">
                “...egy több évtizede,<br>
                legalábbis Magyarországon,<br>
                feledésre ítélt szakma általad kell életre.”
              </div>
            </div>
            <div class="credits">
              Fotó: Bihari Balázs
            </div>
          </div>
          <p>László azt mondja, hogy az alatt a 4 év alatt, amíg ebben az üzletben dolgozott,
            8000-9000 vendége volt, vagyis, ha akkoriban valaki igazán hipster külsővel köszönt
            be egy buliba, akkor biztosan ő, vagy valamelyik barátja fazonírozta a fickót.</p>
          <p>László két éve döntött úgy, hogy tud eleget ahhoz, hogy a dédapja nyomdokaiba
            lépjen és saját üzletet nyit. A fővárosban addigra számtalan szalon nyílt,
            Szentendre azonban még szinte fehér folt volt.</p>
          <p class="quote">„Sokféle üzletben dolgoztam az évek során, láttam a sikereiket,
            kudarcaikat,<br>
            elég színesnek ítélve meg saját tapasztalataimat és mert vonzanak<br>
            a kis manufakturiális rendszerek, nyitottam meg 2018-ban Szentendrén</p>
          <p class="quote endq">a Duna korzón saját üzletemet, Anchor Barber&amp;Shop néven ahol
            egyedül dolgozom,<br>
            hiszen a saját tapasztalataimból tudok vendégeimnek<br>
            egy mindig állandó minőséget biztosítani.”</p>
        </template>
      </article>
    </div>
    <div class="foonav">
      <div class="inner">
        <div class="prevcol">
          <router-link
            class="prev"
            :to="{ name: 'home'}"
          > <img
              class="backhome"
              src="../assets/article/korkep-back.png"
            >
            <img
              class="arrow"
              src="../assets/arrow-l-w.svg"
              alt="Vissza a Barber Shop körképhez"
            >Vissza a Barber Shop körképhez</router-link>
        </div>
        <div class="sponscol">
          <a
            href="http://www.facebook.com/hungariaextradry"
            target="_blank"
          ><img
              class="small"
              src="../assets/hungaria-bottle.png"
            ><img
              class="big"
              src="../assets/article/hungaria-bottle-stand.png"
            ></a>
        </div>
        <div class="nextcol">
          <template v-if="this.$route.name === 'deak'">
            <router-link
              class="next"
              :to="{ name: 'csorbics'}"
            > <img
                class="nextart"
                src="../assets/article/Csorbics_580x440.png"
                alt="Tovább a következő cikkhez"
              >
              <img
                class="arrow"
                src="../assets/arrow-r-w.svg"
                alt="->"
              >Tovább a következő cikkhez</router-link>
          </template>
          <template v-if="this.$route.name === 'csorbics'">
            <router-link
              class="next"
              :to="{ name: 'suto'}"
            > <img
                class="nextart"
                src="../assets/article/Suto_580x440.png"
                alt="Tovább a következő cikkhez"
              >
              <img
                class="arrow"
                src="../assets/arrow-r-w.svg"
                alt="->"
              >Tovább a következő cikkhez</router-link>
          </template>
          <template v-if="this.$route.name === 'suto'">
            <router-link
              class="next"
              :to="{ name: 'deak'}"
            > <img
                class="nextart"
                src="../assets/article/Deak_580x440.png"
                alt="Tovább a következő cikkhez"
              >
              <img
                class="arrow"
                src="../assets/arrow-r-w.svg"
                alt="->"
              >Tovább a következő cikkhez</router-link>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
  },
  mounted() {
    this.$store.dispatch('loadItems');
  },
};
</script>

<style scoped lang="css">
.article {
  position: relative;
}
.leadbg {
  width: 100%;
  height: auto;
}
.headlinecont {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  display: -ms-grid;
  -ms-grid-columns: 50% 50%;
  -ms-grid-rows: auto;
  position: absolute;
  top: 100px;
  width: 100%;
  max-width: 1250px;
}
.textcont {
  grid-column: 2/3;
  grid-row: 1/2;
  -ms-grid-column: 2;
  -ms-grid-row: 1;
}
h1 {
  font-family: "Blacksword";
  font-weight: 400;
  line-height: 1;
  text-align: center;
  margin: 0px;
}
h1 span {
  display: block;
}
.firstname {
  font-size: 88px;
  color: #fff;
}
.lastname {
  font-size: 71px;
  color: #d13138;
  margin-top: -3%;
}
article {
  padding: 30px 110px;
}
h2 {
  font-weight: 900;
  font-size: 24px;
}
p {
  font-family: "Gotham Book";
  font-size: 16px;
  margin-bottom: 25px;
}
.quote {
  text-transform: uppercase;
  font-weight: 500;
  text-align: center;
}
.pictureblock {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto auto;
  display: -ms-grid;
  -ms-grid-columns: 50% 50%;
  -ms-grid-rows: auto;
  align-items: center;
  margin: 30px 0 50px 0;
}
.articlepic {
  grid-column: 1/2;
  grid-row: 1/2;
  -ms-grid-column: 1;
  -ms-grid-row: 1;
  position: relative;
}
.articlepic img {
  width: 100%;
  height: auto;
}
.articlepic:after {
  content: "";
  display: block;
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  border: 3px solid #f2f2f2;
  position: absolute;
  top: 15px;
  left: 30px;
  z-index: -1;
}
.credits {
  grid-column: 1/2;
  grid-row: 2/3;
  -ms-grid-column: 1;
  -ms-grid-row: 2;
  font-family: "Gotham Book";
  font-size: 13px;
  margin-top: 20px;
}
.textcol {
  grid-column: 2/3;
  grid-row: 1/2;
  -ms-grid-column: 2;
  -ms-grid-row: 1;
  padding-left: 60px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
}
.textcol img {
  display: block;
  margin: 0 0 30px 0;
}
.colq {
  font-family: "Minion Pro";
  font-size: 26px;
  text-align: center;
}
.startq,
.endq {
  background-repeat: no-repeat;
  background-position-x: center;
  background-image: url(../assets/article/quote.svg);
  background-size: 160px;
}
.startq {
  background-position-y: top;
}
.endq {
  background-position-y: bottom;
}
.foonav {
  background-color: #1d151c;
}
.foonav .inner {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-rows: auto;
  display: -ms-grid;
  -ms-grid-columns: 1fr auto 1fr;
  -ms-grid-rows: auto;
  padding: 20px 0 0 0;
  align-items: center;
  justify-items: center;
  text-align: center;
}
.prevcol {
  grid-column: 1/2;
  grid-row: 1/2;
  -ms-grid-column: 1;
  -ms-grid-row: 1;
}
.sponscol {
  grid-column: 2/3;
  grid-row: 1/2;
  -ms-grid-column: 2;
  -ms-grid-row: 1;
}
.nextcol {
  grid-column: 3/4;
  grid-row: 1/2;
  -ms-grid-column: 3;
  -ms-grid-row: 1;
}
.nextcol,
.prevcol {
  display: flex;
  justify-content: center;
}
.arrow {
  width: 15px;
  margin-right: 10px;
}
.foonav a {
  text-decoration: none;
  color: #fff;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 2px;
  font-weight: 500;
  align-self: center;
}
.backhome {
  width: 262px;
  display: block;
  margin: 0 auto 15px auto;
  background-color: #251d27;
  padding: 25px 10px;
}
.nextart {
  display: block;
  margin: 0 auto 15px auto;
  width: 285px;
}
.sponscol img.small {
  display: none;
}
@media screen and (max-width: 1310px) {
  .headlinecont {
    max-width: calc(100% - 60px);
  }
}
@media screen and (max-width: 1120px) {
  .headlinecont {
    top: 110px;
  }
  h1 .firstname {
    font-size: 65px;
  }
  h1 .lastname {
    font-size: 48px;
  }
}
@media screen and (max-width: 1000px) {
  .foonav .inner {
    grid-template-rows: auto auto auto;
    -ms-grid-rows: auto auto auto;
  }
  .prevcol {
    grid-column: 1/4;
    grid-row: 1/2;
    -ms-grid-column-span: 3;
    -ms-grid-row: 1;
  }
  .sponscol {
    grid-column: 1/4;
    grid-row: 2/3;
    -ms-grid-column-span: 3;
    -ms-grid-row: 2;
  }
  .nextcol {
    grid-column: 1/4;
    grid-row: 3/4;
    -ms-grid-column-span: 3;
    -ms-grid-row: 3;
  }
  .prevcol,
  .sponscol,
  .nextcol {
    margin: 20px;
  }
  .sponscol img.big {
    display: none;
  }
  .sponscol img.small {
    display: block;
    max-width: 300px;
  }
}
@media screen and (max-width: 910px) {
  .headlinecont {
    top: 80px;
  }
}
@media screen and (max-width: 810px) {
  h1 .firstname {
    font-size: 55px;
  }
  h1 .lastname {
    font-size: 38px;
  }
}
@media screen and (max-width: 767px) {
  .article {
    overflow: hidden;
  }
  .headlinecont {
    top: 80px;
    grid-template-columns: 30% 70%;
    -ms-grid-columns: 30% 70%;
  }
  .leadbg {
    width: initial;
    height: 290px;
    left: -5%;
    position: relative;
  }
  .csorbics .leadbg {
    left: -43%;
  }
  .suto .leadbg {
    left: -40%;
  }
  article {
    padding: 30px 0px;
  }
  .pictureblock {
    grid-template-rows: auto auto;
    -ms-grid-rows: auto auto auto;
    padding: 0 20px;
  }
  .articlepic {
    grid-column: 1/3;
    -ms-grid-column-span: 2;
    max-width: 540px;
    justify-self: center;
  }
  .credits {
    grid-column: 1/3;
    -ms-grid-column-span: 2;
  }
  .textcol {
    grid-column: 1/3;
    grid-row: 3/4;
    -ms-grid-column-span: 2;
    -ms-grid-row: 3;
    margin-top: 60px;
    flex-wrap: wrap;
    padding-left: 0px;
  }
  .colq {
    flex-basis: 100%;
  }
  @media screen and (max-width: 480px) {
    .csorbics .leadbg,
    .suto .leadbg {
      left: -80%;
    }
    .headlinecont {
      grid-template-columns: 10% 90%;
      -ms-grid-columns: 10% 90%;
    }
  }
}
</style>
